module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container bills"
  }, [_vm._m(0), _c('auto-edit-table', {
    ref: "edittable",
    attrs: {
      "title": "收支明细",
      "defines": _vm.$defines.bill,
      "data": _vm.filtered,
      "pagesize": 20,
      "detail-view": "detail-view",
      "summary": "summary",
      "unstackable": "unstackable",
      "sortable": "sortable",
      "button-add": _vm.$permission.has("basic.create.bills"),
      "actions": _vm.actions,
      "page-reset-on-change": false
    },
    on: {
      "action:print": _vm.select_bill,
      "action:print_select": _vm.cancel_bill,
      "action:mark_verified": _vm.mark_verified,
      "action:mark_review": _vm.mark_review,
      "action:mark_invalid": _vm.mark_invalid
    }
  }, [_c('template', {
    slot: "afterTitle"
  }, [_c('balance-bar', {
    attrs: {
      "date": _vm.time_end,
      "state": _vm.select_state
    }
  }), _c('filters-group', {
    attrs: {
      "data": _vm.bills,
      "result": _vm.filtered
    },
    on: {
      "update:result": function($event) {
        _vm.filtered = $event
      },
      "update:states": function (i) { return _vm.filterState = i; }
    }
  }, [_c('div', {
    staticClass: "ui two columns stackable form grid filters"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('h4', [_vm._v("状态")]), _c('filter-select', {
    attrs: {
      "filter": _vm.$defines.bill.filters.state,
      "select": _vm.select_state
    },
    on: {
      "update:select": function($event) {
        _vm.select_state = $event
      }
    }
  }), _c('h4', [_vm._v("时间")]), _c('filter-date-range', {
    attrs: {
      "filter": _vm.$defines.bill.filters.date,
      "select": _vm.select_time,
      "start": _vm.time_start,
      "end": _vm.time_end
    },
    on: {
      "update:select": function($event) {
        _vm.select_time = $event
      },
      "update:start": function($event) {
        _vm.time_start = $event
      },
      "update:end": function($event) {
        _vm.time_end = $event
      }
    }
  })], 1), _c('div', {
    staticClass: "column"
  }, [_c('h4', [_vm._v("类型")]), _c('filter-select', {
    attrs: {
      "filter": _vm.$defines.bill.filters.types,
      "select": _vm.select_type
    },
    on: {
      "update:select": function($event) {
        _vm.select_type = $event
      }
    }
  }), _c('h4', [_vm._v("搜索")]), _c('filter-search', {
    attrs: {
      "filter": _vm.$defines.bill.filters.search,
      "defines": _vm.$defines.bill,
      "placeholder": "搜索..."
    }
  })], 1)])])], 1)], 2), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.print_selected.length),
      expression: "print_selected.length"
    }],
    staticClass: "print-float"
  }, [_c('div', {
    staticClass: "ui icon button themed",
    on: {
      "click": function($event) {
        _vm.print()
      },
      "contextmenu": function($event) {
        $event.preventDefault();
        _vm.clear_select_bills()
      }
    }
  }, [_c('i', {
    staticClass: "icon print big"
  }), _c('br'), _c('br'), _c('p', [_vm._v("打印")])]), _c('div', {
    staticClass: "floating ui orange label small circular"
  }, [_vm._v(_vm._s(_vm.print_selected.length))])]), _c('el-dialog', {
    attrs: {
      "title": "选择打印格式",
      "visible": _vm.dialog_printing,
      "size": "small",
      "before-close": _vm.printing_close
    },
    on: {
      "update:visible": function($event) {
        _vm.dialog_printing = $event
      }
    }
  }, [_c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', {
    staticClass: "ui button blue",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.print_fee()
      }
    }
  }, [_vm._v("补打收款收据")]), _c('div', {
    staticClass: "ui button orange",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.print_bills()
      }
    }
  }, [_vm._v("打印财务账单")]), _c('div', {
    staticClass: "ui button",
    on: {
      "click": function($event) {
        _vm.dialog_printing = false
      }
    }
  }, [_vm._v("取消")])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui warning message hide-in-desktop"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._v("移动设备兼容性")]), _c('p', [_vm._v("收支明细对移动设备兼容不佳，建议在电脑上进行操作。")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a1bda3a8","hasScoped":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/src/pages/Bills.vue
// module id = 351
// module chunks = 0